import { createStore } from "vuex";
import { config } from "vuex-module-decorators";
import axios from "@/core/services/axios";

import AuthModule from "@/store/modules/AuthModule";
import BodyModule from "@/store/modules/BodyModule";
import BreadcrumbsModule from "@/store/modules/BreadcrumbsModule";
import ConfigModule from "@/store/modules/ConfigModule";
import ThemeModeModule from "@/store/modules/ThemeModeModule";
import UserModule from "@/store/modules/user/user";
import TokensModule from "asokoinsight-tokens/src/vuex/tokens";
import investeeModule from "@/store/modules/investee/investee";
import messagesModule from "@/store/modules/messages/messages";
import logsModule from "./modules/logs/logs";
import intermediaryModule from "./modules/intermediary/intermediary";
import investorModule from "./modules/investor/investor";
import platformModule from "./modules/platform/platform";
import accountModule from "./modules/account/account";

config.rawError = true;

const store = createStore({
  modules: {
    AuthModule,
    BodyModule,
    BreadcrumbsModule,
    ConfigModule,
    ThemeModeModule,
    user: UserModule,
    tokens: TokensModule,
    investee: investeeModule,
    messages: messagesModule,
    logs: logsModule,
    intermediary: intermediaryModule,
    investor: investorModule,
    platform: platformModule,
    account: accountModule,
  },
});

store.$http = axios;

export default store;
